import { AuthShell } from '@/Ship/Components/Auth/AuthShell'

import type { AuthShellProps } from '@/Ship/Components/Auth/AuthShell'

export type FormWrapperProps = AuthShellProps

/**
 * Оболонка публічних форм (вхід, відновлення пароля).
 *
 * Сам вигляд — у Ship (`AuthShell`), бо ту саму оболонку використовує
 * `templateError403`: форма входу з'являється двома різними шляхами, і оформити
 * треба обидва. Тут лишається тільки ім'я, під яким її знає контейнер.
 */
export const FormWrapper = ({ children, showLogo = true }: FormWrapperProps) => (
    <AuthShell showLogo={showLogo}>{children}</AuthShell>
)
